import { z } from 'zod';
import {
  emailValidation,
  nameValidation,
  phoneValidation,
  requiredTrimmedString,
} from '../../validation';

// The loved one a member nominates on the referral form ("Nominate a loved
// one", PPL-3600). Any organization's referral may carry one — only the
// Vitality form collects it today. At most one, and data-only for go-live:
// no account, no identity, no access. The field names are the contract with
// the patient platform, which receives the nominee via the booking link and
// maps them to a FHIR RelatedPerson with the stated relationship.
export const ReferralNomineeSchema = z
  .object({
    firstName: nameValidation('Nominee first name is required'),
    lastName: nameValidation('Nominee surname is required'),
    email: emailValidation('Nominee email is required'),
    relationship: requiredTrimmedString('Nominee relationship is required'),
    phone: phoneValidation().optional(),
  })
  .optional();

export type ReferralNominee = NonNullable<
  z.infer<typeof ReferralNomineeSchema>
>;
